/** STREFA, WEJŚCIE, NAZWISKO I IMIĘ, NR EWID, KOMÓRKA — proportions of the design frame. */
export const CURRENT_PRESENCE_OWNERS_COLUMNS = '1fr 1.1fr 1.3fr 0.6fr 1.2fr';
